import { Action } from "redux";
import { OrganizationKeyName } from "../../../model/Organization";

export const GET_UI_SETTINGS_FAIL = "ORGANIZATION:GET_UI_SETTINGS_FAIL";

export interface GetUISettingsFailAction extends Action {
  type: typeof GET_UI_SETTINGS_FAIL;
  organization: OrganizationKeyName;
}

export const getUISettingsFail = (
  organization: OrganizationKeyName
): GetUISettingsFailAction => ({
  type: GET_UI_SETTINGS_FAIL,
  organization,
});
